import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import Footer from "../../components/Common/Footer/Footer";
import Header from "../../components/Common/Header/Header";
import Sidebar from "../../components/Common/Sidebar/Sidebar";
import classes from "./MainPage.module.scss";
import ChangePasswordModal from "../../components/Home/ChangePasswordModal/ChangePasswordModal";
import { useDispatch } from "react-redux";
import getTenantName from "../../utils/getTenantName";
import VideoProgressBar from "../../components/Common/VideoProgressBar/VideoProgressBar";
import {
  getMyProfileActionHandler,
  getTenantPermissionInfoActionHandler,
  getUserRoleMenuActionHandler,
} from "../../store/actions/actionHandlers/commonActionHandler";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "../../api/axios";
const MainPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const tenantName = getTenantName(dispatch, location);

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    dispatch(getUserRoleMenuActionHandler());
    dispatch(getMyProfileActionHandler());
    dispatch(getTenantPermissionInfoActionHandler(navigate));
  }, [dispatch]);

  useEffect(() => {
    if (tenantName) {
      if (location.pathname === `/${tenantName}`) {
        navigate(`/${tenantName}/home`);
      } else if (!location.pathname.includes(tenantName)) {
        navigate(`/${tenantName}/noPageFound`);
      }
    }
  }, [location, navigate, tenantName, dispatch]);

  //   const checkRouteFooterFalse = () =>{
  //     if(location.pathname === `/${tenantName}/myprofile` || location.pathname === `/${tenantName}/changepassword` || `/${tenantName}/contactus`){
  //       return null;
  //     }else {
  //       return <Footer />
  //     }
  // }
  return (
    <div className={classes.mainPage}>
      <Header />
      <main className={classes.mainPage__mainSection}>
        <Sidebar />
        <section className={classes.mainPage__mainSection__mainLayout}>
          <Outlet context={{ tenantName }} />
          {/* {checkRouteFooterFalse()} */}
          {location.pathname === `/${tenantName}/userProfile/myProfile` ||
          location.pathname === `/${tenantName}/userProfile/changePassword` ||
          location.pathname === `/${tenantName}/userProfile/contactUs` ? (
            <></>
          ) : (
            <Footer />
          )}
        </section>
      </main>
      <ChangePasswordModal />
      <VideoProgressBar />
    </div>
  );
};

export default MainPage;
